'use client';
import React from 'react';
import DashboardLayout from '@/components/DashboardLayout';
import AdminOnboardingReview from '@/app/admin-dashboard/components/AdminOnboardingReview';

export default function AdminOnboardingPage() {
  return (
    <DashboardLayout role="admin">
      <div className="space-y-6">
        <div>
          <h1 className="text-2xl font-extrabold text-foreground">Cleaner Onboarding</h1>
          <p className="text-sm text-muted-foreground mt-0.5">Review and approve cleaner verification documents</p>
        </div>
        <AdminOnboardingReview />
      </div>
    </DashboardLayout>
  );
}
